module.exports = __webpack_public_path__ + "assets/img/Striver-Careers-Landing-Page.19a73e9a.jpg";